<template>
  <div class="p-configurator" id="simulation">
    <side-banner :td_id="td_id.number" :car_id="carid.number" :p_url="p_url.p_url" />
    <the-title :title="title" />
    <step-menu />
    <div class="p-configurator__inner result">
      <section class="fv_area">
        <div class="result__exterior">
          <img class="main_img" :src="simulation.bodyimage" alt="" />
        </div>
        <div class="result__interior">
          <span v-for="item in simulation.innerimage" :key="item">
            <img :src="item" alt="" class="sub_img" />
          </span>
          <div class="asidebnr_fv">
            <div class="asidebnr__inner_fv">
              <form
                id="loanSimulation"
                :action="loanSumirationPath"
                method="post"
                novalidate="true"
                target="_blank"
              >
                <input
                  :value="simulation.LOAN_CAR_MODEL"
                  type="hidden"
                  name="CAR_MODEL"
                />
                <input
                  :value="simulation.LOAN_CAR_GRADE"
                  type="hidden"
                  name="CAR_GRADE"
                />
                <input
                  :value="simulation.LOAN_VEHICLE_PRICE"
                  type="hidden"
                  name="VEHICLE_PRICE"
                />
                <input
                  :value="simulation.LOAN_OP_COLOR"
                  type="hidden"
                  name="OP_COLOR"
                />
                <input
                  :value="simulation.LOAN_OP_ACCESSORY"
                  type="hidden"
                  name="OP_ACCESSORY"
                />
                <input
                  :value="simulation.LOAN_OP_OTHER"
                  type="hidden"
                  name="OP_OTHER"
                />

                <button type="submit" value="Submit" class="btn" alt="">
                  ローンシミュレーション
                  <img
                    src="../../public/images/Vector2.svg"
                    class="space"
                    alt=""
                  />
                </button>
              </form>
            </div>
            <div class="asidebnr__inner_fv" v-if="simulation.estimate==='true'">
              <form
                id="estimate"
                :action="estimatePath"
                method="post"
                novalidate="true"
                target="_blank"
              >
                <input
                  :value="simulation.ESTIMATE_CAR_MODEL"
                  type="hidden"
                  name="CAR_MODEL"
                />
                <input
                  :value="simulation.ESTIMATE_CAR_GRADE"
                  type="hidden"
                  name="CAR_GRADE"
                />
                <input
                  :value="simulation.ESTIMATE_BODY_COLOR"
                  type="hidden"
                  name="BODY_COLOR"
                />
                <input
                  :value="simulation.ESTIMATE_OPTION"
                  type="hidden"
                  name="OPTION"
                />
                <input
                  :value="simulation.ESTIMATE_OPTION_S"
                  type="hidden"
                  name="OPTION_S"
                />

                <button type="submit" value="Submit" class="btn">
                  見積依頼
                  <img
                    src="../../public/images/Vector2.svg"
                    class="space"
                    alt=""
                  />
                </button>
              </form>
            </div>
            <div class="asidebnr__inner_fv">
              <form
                id="loanSimulation"
                :action="simulation.purchase_url"
                method="post"
                novalidate="true"
                target="_blank"
              >
                <button type="submit" value="Submit" class="btn" alt="">
                  購入相談
                  <img
                    src="../../public/images/Vector2.svg"
                    class="space"
                    alt=""
                  />
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section class="fv_summary">
        <div class="fv_summary__head">
          <div>
            <p class="section_title renalutFont">
              {{ simulation.title }}
              <template v-if="(simulation.code==='MS')">INTENS</template><template v-else-if="(simulation.grade==='R.S.')"></template><template v-else>{{ simulation.grade }}</template>
            </p>
          </div>
          <div>
            <p class="item_value">
              概算見積価格（税込）<span class="sum_price">¥ 
                {{ simulation.total_price }}</span
              >
            </p>
          </div>
        </div>
        <div class="fv_summary__line">
          <div class="fv_summary__value">
            <p class="fv_summary__linetitle">カラー</p>
            <p class="">
              {{ simulation.name_exterior }} / {{ simulation.name_interior }}
            </p>
          </div>

          <div class="fv_summary__value" v-if="existsMakerOption">
            <p class="fv_summary__linetitle">メーカーオプション</p><p>
            <template
              :class="{ fv_summary__child: makerOptionIsShow(item_group.name) }"
              v-for="item_group in simulation.maker_options"
              :key="item_group.name"
            >
              <template class="" v-if="makerOptionIsShow(item_group.name)">
<!--            {{ item_group.name }}： -->
              </template>
              <span v-for="item in item_group.list" :key="item.name" class="summary_split">
                {{ item.name }}
              </span>
            </template>
            <template class="" v-if="selectMakerOptionNumber === 0">
              選択されていません
            </template></p>
          </div>
          <div class="fv_summary__value">
            <p class="fv_summary__linetitle">アクセサリー</p><p>
            <template
              :class="{ fv_summary__child: optionIsShow(item_group.name) }"
              v-for="item_group in simulation.accessories"
              :key="item_group.name"
            >
              <template class="" v-if="optionIsShow(item_group.name)">
<!--            {{ item_group.name }}： -->
              </template>
              <span v-for="item in item_group.list" :key="item.name" class="summary_split">
                {{ item.name }}
              </span>
            </template>
            <template class="" v-if="selectOptionNumber === 0">
              選択されていません
            </template></p>
          </div>
          <div class="fv_summary__value">
            <p class="fv_summary__linetitle">アフターサービス</p><p>
            <template
              :class="{ fv_summary__child: serviceIsShow(item_group.name) }"
              v-for="item_group in simulation.services"
              :key="item_group.name"
            >
              <template
                class="item_title"
                v-if="serviceIsShow(item_group.name)"
              >
                {{ item_group.name }}：
              </template>
              <span v-for="item in item_group.list" :key="item.name" class="summary_split">
                {{ item.name }}
              </span>
            </template>
            <template class="" v-if="selectServiceNumber === 0">
              選択されていません
            </template>
            </p>
          </div>
        </div>
      </section>

      <!--以下暫定変更なし-->

      <div class="result__wrapper">
        <div class="result__estimate">
          <div class="result__estimate__inner">
            <div>
              <p class="section_title">見積詳細</p>
            </div>
            <!-- <div>
            <p class="item_value">
              <span class="sum_price"> {{ simulation.total_price }}</span
              >円（税込）
            </p>
          </div> -->
          </div>
        </div>
        <div class="result__enditem">
          <h3 class="item_title_head">グレード</h3>
          <div class="item_btn">
            <button class="choice_btn" @click="backBtnClick('grade')">
              選択に戻る
            </button>
          </div>
        </div>
        <div class="result__enditem">
          <p class="item_title renalutFont">{{ simulation.title }}</p>
          <!-- <p class="item_value renalutFont">{{ simulation.grade }}</p> -->
          <p class="item_value renalutFont"><template v-if="(simulation.code==='MS')">INTENS</template><template v-else>{{ simulation.grade }}</template></p>
          <p class="item_btn">
            <span>¥ {{ simulation.grade_price }}</span
            >
          </p>
        </div>
      </div>

      <div class="result__wrapper">
        <div class="result__enditem">
          <h3 class="item_title_head">カラー</h3>
          <div class="item_btn">
            <button class="choice_btn" @click="backBtnClick('color')">
              選択に戻る
            </button>
          </div>
        </div>
        <div class="result__enditem">
          <p class="item_title">エクステリア</p>
          <p class="item_value">{{ simulation.name_exterior }}</p>
          <p class="item_btn">
            <span>¥ {{ simulation.price_exterior }}</span
            >
          </p>
        </div>
        <div class="result__enditem">
          <p class="item_title">インテリア</p>
          <p class="item_value">{{ simulation.name_interior }}</p>
          <p class="item_btn">
            <span>¥ {{ simulation.price_interior }}</span
            >
          </p>
        </div>
      </div>
      <div class="result__wrapper" v-if="existsMakerOption">
        <div class="result__enditem">
          <h3 class="item_title_head">メーカーオプション</h3>
          <div class="item_btn">
            <button class="choice_btn" @click="backBtnClick('option', 'maker_options')">
              選択に戻る
            </button>
          </div>
        </div>

        <div
          :class="{ result__enditem: makerOptionIsShow(item_group.name) }"
          v-for="item_group in simulation.maker_options"
          :key="item_group.name"
        >
          <p class="item_title" v-if="makerOptionIsShow(item_group.name)">
            {{ item_group.name }}
          </p>
          <template v-for="item in item_group.list" :key="item.name">
            <p class="item_value">{{ item.name }}</p>
            <p class="item_btn">
              <span>¥ {{ item.price }}</span>
            </p>
          </template>
        </div>
        <div class="result__enditem" v-if="selectMakerOptionNumber === 0">
          <p class="item_title item_noselect">選択されていません</p>
        </div>
      </div>
      <div class="result__wrapper">
        <div class="result__enditem">
          <h3 class="item_title_head">アクセサリー</h3>
          <div class="item_btn">
            <button class="choice_btn" @click="backBtnClick('option', 'accessories')">
              選択に戻る
            </button>
          </div>
        </div>

        <div
          :class="{ result__enditem: optionIsShow(item_group.name) }"
          v-for="item_group in simulation.accessories"
          :key="item_group.name"
        >
          <p class="item_title" v-if="optionIsShow(item_group.name)">
            {{ item_group.name }}
          </p>
          <template v-for="item in item_group.list" :key="item.name">
            <p class="item_value">{{ item.name }}</p>
            <p class="item_btn">
              <span>¥ {{ item.price }}</span>
            </p>
          </template>
        </div>
        <div class="result__enditem" v-if="selectOptionNumber === 0">
          <p class="item_title item_noselect">選択されていません</p>
        </div>
      </div>
      <div class="result__wrapper">
        <div class="result__enditem">
          <h3 class="item_title_head">アフターサービス</h3>
          <div class="item_btn">
            <button class="choice_btn" @click="backBtnClick('option', 'services')">
              選択に戻る
            </button>
          </div>
        </div>
        <div
          :class="{ result__enditem: serviceIsShow(item_group.name) }"
          v-for="item_group in simulation.services"
          :key="item_group.name"
        >
          <p class="item_title" v-if="serviceIsShow(item_group.name)">
            {{ item_group.name }}
          </p>
          <template v-for="item in item_group.list" :key="item.name">
            <p class="item_value">{{ item.name }}</p>
            <p class="item_btn">
              <span>¥ {{ item.price }}</span
              >
            </p>
          </template>
        </div>
        <div class="result__enditem" v-if="selectServiceNumber === 0">
          <p class="item_title item_noselect">選択されていません</p>
        </div>
        <p class="result__note">※金額は全て税込表記となります</p>
      </div>

      <section class="simulation_detail">
        <p class="section_title">選択詳細</p>

        <div class="result__wrapper">
          <h3 class="result__ttl renalutFont">{{ simulation.title }}</h3>
          <p class="result__list result__list__title">主要装備</p>
          <div
            v-for="(grade, index) in splitComma(simulation.grade_equipment)"
            :key="index"
          >
            {{ grade }}
          </div>
        </div>

        <div class="result__wrapper">
          <h3 class="result__ttl">エンジン</h3>
          <p class="result__list">
            <span>{{ simulation.engine_name }}</span>
          </p>
          <p class="result__list enable_wrap">
            <span>最高出力（kw (ps) /rpm）</span>{{ simulation.engine_max_power }}
          </p>
          <p class="result__list">
            <span
              >燃料消費率WLTCモード（{{ simulation.engine_fuel_type }}）</span
            >
            {{ simulation.engine_fuel_consumption_rate }} 
          </p>
          <p class="result__list" v-if="simulation.engine_fuel2">
            <span
              >{{simulation.engine_fuel2}}（{{ simulation.engine_fuel2_type }}）</span
            >
            {{ simulation.engine_fuel2_consumption_rate }} 
          </p>
        </div>

        <div class="result__wrapper" v-if="selectMakerOptionNumber !== 0">
          <h3 class="result__ttl">メーカーオプション</h3>
          <template v-for="item_group in simulation.maker_options" :key="item_group.name">
            <p v-if="makerOptionIsShow(item_group.name)" class="result__list">
              <span>{{ item_group.name }}</span>
            <template v-for="item in item_group.list" :key="item.name">
              {{ item.name }}
            </template>
          </p>
          </template>
        </div>
        <div class="result__wrapper" v-if="selectOptionNumber !== 0">
          <h3 class="result__ttl">オプション</h3>
          <template v-for="item_group in simulation.accessories" :key="item_group.name">
            <p v-if="optionIsShow(item_group.name)" class="result__list">
              <span>{{ item_group.name }}</span>
            <template v-for="item in item_group.list" :key="item.name">
              {{ item.name }}
            </template>
          </p>
          </template>
        </div>
        <div class="result__wrapper" v-if="selectServiceNumber !== 0">
          <h3 class="result__ttl">アフターサービス</h3>
          <template v-for="item_group in simulation.services" :key="item_group.name">
            <p v-if="serviceIsShow(item_group.name)" class="result__list">
              <span>{{ item_group.name }}</span>
            <template v-for="item in item_group.list" :key="item.name">
              {{ item.name }}
            </template>
          </p>
          </template>
        </div>
      </section>

      <div class="asidebnr">
        <div class="asidebnr__inner">
          <p class="ttl">
            見積依頼で分割払いの<br class="pc_hid" />シミュレーションが可能です
          </p>
          <form
            id="loanSimulation"
            :action="loanSumirationPath"
            method="post"
            novalidate="true"
            target="_blank"
          >
            <input
              :value="simulation.LOAN_CAR_MODEL"
              type="hidden"
              name="CAR_MODEL"
            />
            <input
              :value="simulation.LOAN_CAR_GRADE"
              type="hidden"
              name="CAR_GRADE"
            />
            <input
              :value="simulation.LOAN_VEHICLE_PRICE"
              type="hidden"
              name="VEHICLE_PRICE"
            />
            <input
              :value="simulation.LOAN_OP_COLOR"
              type="hidden"
              name="OP_COLOR"
            />
            <input
              :value="simulation.LOAN_OP_ACCESSORY"
              type="hidden"
              name="OP_ACCESSORY"
            />
            <input
              :value="simulation.LOAN_OP_OTHER"
              type="hidden"
              name="OP_OTHER"
            />

            <button type="submit" value="Submit" class="btn" alt="">
              ローンシミュレーション
              <img src="../../public/images/Vector2.svg" class="space" alt="" />
            </button>
          </form>
        </div>
        <div class="asidebnr__inner" v-if="simulation.estimate==='true'">
          <p class="ttl">
            お近くのディーラー店舗で<br
              class="pc_hid"
            />詳細見積のご相談ができます
          </p>
          <form
            id="estimate"
            :action="estimatePath"
            method="post"
            novalidate="true"
            target="_blank"
          >
            <input
              :value="simulation.ESTIMATE_CAR_MODEL"
              type="hidden"
              name="CAR_MODEL"
            />
            <input
              :value="simulation.ESTIMATE_CAR_GRADE"
              type="hidden"
              name="CAR_GRADE"
            />
            <input
              :value="simulation.ESTIMATE_BODY_COLOR"
              type="hidden"
              name="BODY_COLOR"
            />
            <input
              :value="simulation.ESTIMATE_OPTION"
              type="hidden"
              name="OPTION"
            />
            <input
              :value="simulation.ESTIMATE_OPTION_S"
              type="hidden"
              name="OPTION_S"
            />

            <button type="submit" value="Submit" class="btn">
              見積依頼
              <img src="../../public/images/Vector2.svg" class="space" alt="" />
            </button>
          </form>
        </div>
        <div class="asidebnr__inner">
          <p class="ttl">
            お近くのディーラー店舗で<br class="pc_hid" />購入のご相談ができます
          </p>
          <form
            id="loanSimulation"
            :action="simulation.purchase_url"
            method="post"
            novalidate="true"
            target="_blank"
          >
            <button type="submit" value="Submit" class="btn" alt="">
              購入相談
              <img src="../../public/images/Vector2.svg" class="space" alt="" />
            </button>
          </form>
        </div>
      </div>
    </div>
    <bottom-banner :td_id="td_id.number" :car_id="carid.number" :p_url="p_url.p_url" />
  </div>
</template>

<script>
import { props, context, inject, reactive, ref, onMounted } from "vue";
import RjConfiguration from "../functions/RjConfiguration";
import TheTitle from "../components/Title.vue";
import StepMenu from "../components/StepMenu.vue";
import axios from "axios";
import SideBanner from "../components/SideBanner.vue";
import BottomBanner from "../components/BottomBanner.vue";

export default {
  components: {
    TheTitle,
    StepMenu,
    SideBanner,
    BottomBanner,
  },
  setup(props, context) {
    const RJ = RjConfiguration();
    const title = RJ.getTitle();
    const item_list = RJ.getListGrade();
    const select_car = RJ.getDataCar();
    const select_engine = RJ.getDataEngine();
    const item_car = RJ.getDataCar();
    const select_grade = RJ.getDataGreade();
    const select_color = RJ.getDataColor();
    const existsMakerOption = RJ.existsMakerOption();
    const select_maker_options = RJ.getDataMakerOptions();
    const select_accessories = RJ.getDataAccessories();
    const select_services = RJ.getDataServices();
    const total_price = RJ.getTotalPrice();
    let td_id = reactive({ number: item_car.testdrive_id });
    let carid = reactive({ number: item_car.catalog_id });
    let p_url = reactive({ p_url: item_car.purchase_url });

    const car_model = ref(select_car.name_jp);
    let car_grade_jp = ref(select_grade.name_jp);
    let car_grade_en = ref(select_grade.name);
    const car_grade = (car_grade_jp.value != '')? car_grade_jp.value : car_grade_en.value;
    const body_color = ref(select_color.name);
    const maker_option = ref(select_maker_options);
    const option = ref(select_accessories);
    const service = ref(select_services);
    let selected_option_array = [];
    let selected_option_price = ref(0);
    let selected_service_array = [];
    let selected_service_price = ref(0);

    const loanSumirationPath = process.env.VUE_APP_RJ_LOANSIMULATION_PATH;
    const estimatePath = process.env.VUE_APP_RJ_ESTIMATE_PATH;

    let simulation = {
      bodyimage: select_color.image,
      innerimage: select_color.inner_image,
      price: select_car.base_price,
      title: select_car.name,
      code: select_car.code,
      purchase_url: select_car.purchase_url,
      estimate: (typeof select_car.estimate == 'undefined' ) ? "true" : select_car.estimate,
      grade: select_grade.name,
      grade_code: select_grade.code,    // 2023.01.26 追加
      grade_price: select_grade.price,
      grade_equipment: select_grade.major_equipment,
      name_exterior: select_color.name,
      name_interior: select_color.name_interior,
      price_exterior: select_color.price,
      price_interior: 0,
      maker_options: select_maker_options,
      accessories: select_accessories,
      services: select_services,
      engine_name: select_engine.name,
      engine_max_power: select_engine.max_power,
      engine_fuel_consumption_rate: select_engine.fuel_consumption_rate,
      engine_fuel_type: select_engine.fuel_type,
      engine_fuel2: select_grade.grade_fuel2,
      engine_fuel2_consumption_rate: select_grade.grade_fuel2_consumption_rate,
      engine_fuel2_type: select_grade.grade_fuel2_type,
      total_price: total_price,

      LOAN_CAR_MODEL: select_car.loan_car_model,
      LOAN_CAR_GRADE: select_grade.loan_car_grade,
      LOAN_VEHICLE_PRICE: RJ.priceRemoveComma(select_grade.price),
      LOAN_OP_COLOR: RJ.priceRemoveComma(select_color.price),
      LOAN_OP_ACCESSORY: selected_service_price.value,
      LOAN_OP_OTHER: selected_service_price.value,

      ESTIMATE_CAR_MODEL: encodeURI(car_model.value),
      ESTIMATE_CAR_GRADE: encodeURI(car_grade),
      ESTIMATE_BODY_COLOR: encodeURI(body_color.value),
      ESTIMATE_OPTION: selected_option_array,
      ESTIMATE_OPTION_S: selected_service_array,
    };

    /*    
    // 2023.01.26 追加 CAPTUR E-TECH HYBRID の見積依頼ポタン非表示
    if (simulation.grade_code == "CA-H" || simulation.grade_code == "CA-I") {
      simulation.estimate = "false";
    }
    */

    //選択したオプションを配列に入れ直す
    const getSlectedOption = () => {
      // メーカーオプション
      for (let i = 0; i < maker_option.value.length; i++) {
        if (maker_option.value[i].list.length !== 0) {
          selected_option_array.push(maker_option.value[i].list[0].name.replace(/\r?\n/g, ""));
          selected_option_price.value =
            selected_option_price.value +
            RJ.priceRemoveComma(maker_option.value[i].list[0].price);
        }
      }
      // アクセサリー
      for (let i = 0; i < option.value.length; i++) {
        if (option.value[i].list.length !== 0) {
          selected_option_array.push(option.value[i].list[0].name.replace(/\r?\n/g, ""));
          selected_option_price.value =
            selected_option_price.value +
            RJ.priceRemoveComma(option.value[i].list[0].price);
        }
      }
      simulation.LOAN_OP_ACCESSORY = selected_option_price.value;
      simulation.ESTIMATE_OPTION = encodeURI(selected_option_array);
    };
    //選択したサービスを配列に入れ直す
    const getSlectedService = () => {
      for (let i = 0; i < service.value.length; i++) {
        if (service.value[i].list.length !== 0) {
          selected_service_array.push(
            "ルノー " + service.value[i].list[0].name
          );
          selected_service_price.value =
            selected_service_price.value +
            RJ.priceRemoveComma(service.value[i].list[0].price);
        }
      }
      simulation.LOAN_OP_OTHER = selected_service_price.value;
      simulation.ESTIMATE_OPTION_S = encodeURI(selected_service_array);
    };

    let menu_view_number = 0;
    const splitComma = (data) => {
      return data.split(",");
    };
    const backBtnClick = (routeName, tabMode) => {
      if (routeName === "option") {
        RJ.setOptionMode(tabMode);
      }
      menu_view_number = RJ.getMenuList().findIndex(
        ({ name }) => name === routeName
      );
      RJ.gotoMenu(menu_view_number);
    };

    getSlectedService();
    getSlectedOption();

    const makerOptionIsShow = (e) => {
      let isShow = false;
      for (let i = 0; i < maker_option.value.length; i++) {
        if (maker_option.value[i].list.length !== 0) {
          if (maker_option.value[i].list[0].group === e) {
            isShow = true;
            return isShow;
          } else {
          }
        }
      }
    };
    const optionIsShow = (e) => {
      let isShow = false;
      for (let i = 0; i < option.value.length; i++) {
        if (option.value[i].list.length !== 0) {
          if (option.value[i].list[0].group === e) {
            isShow = true;
            return isShow;
          } else {
          }
        }
      }
    };
    const serviceIsShow = (e) => {
      let isShow = false;
      for (let i = 0; i < service.value.length; i++) {
        if (service.value[i].list.length !== 0) {
          if (service.value[i].list[0].group === e) {
            isShow = true;
            return isShow;
          } else {
          }
        }
      }
    };
    let selectMakerOptionNumber = ref(null);
    let selectOptionNumber = ref(null);
    let selectServiceNumber = ref(null);
    onMounted(() => {
      selectMakerOptionNumber.value = 0;
      for (let i = 0; i < maker_option.value.length; i++) {
        selectMakerOptionNumber.value =
        selectMakerOptionNumber.value + maker_option.value[i].list.length;
      }
      selectOptionNumber.value = 0;
      for (let i = 0; i < option.value.length; i++) {
        selectOptionNumber.value =
          selectOptionNumber.value + option.value[i].list.length;
      }
      selectServiceNumber.value = 0;
      for (let i = 0; i < service.value.length; i++) {
        selectServiceNumber.value =
          selectServiceNumber.value + service.value[i].list.length;
      }
    });
    return {
      menu_view_number,
      title,
      simulation,
      backBtnClick,
      total_price,
      item_list,
      splitComma,
      td_id,
      carid,
      p_url,
      existsMakerOption,
      makerOptionIsShow,
      optionIsShow,
      serviceIsShow,
      selectMakerOptionNumber,
      selectOptionNumber,
      selectServiceNumber,
      loanSumirationPath,
      estimatePath,
    };
  },
};
</script>
<style lang="scss" scoped>
.choice_btn {
  color: #000;
}
</style>
